import React, { useState, useEffect } from "react";
import { Modal, Button, Container } from "react-bootstrap";
import { Nav } from "react-bootstrap";
import {
  englishData,
  sinhalaData,
  tamilData,
} from "../../dummyData/HomeDummyData";
import { useSelector } from "react-redux";
import "./PaperSelectModal.css";
import LanguageRadioButtons from "../LanguageRadioButtons/LanguageRadioButtons";

function ChangePaperModal({ showModal, handleClose }) {
  const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(sinhalaData[0]);

  const handleOpenPaper = (route) => {
    handleClose();
    setTimeout(() => {
      window.location.href = route;
    });
  };

  useEffect(() => {
    switch (selectedLanguage.value) {
      case "english":
        setLanguage(englishData[0]);
        break;
      case "tamil":
        setLanguage(tamilData[0]);
        break;
      default:
        setLanguage(sinhalaData[0]);
        break;
    }
  }, [selectedLanguage]);

  return (
    <Modal
      show={showModal}
      onHide={handleClose}
      size="lg"
      className="modal-top"
    >
      <Modal.Header closeButton>
        <div className="w-100">
          <Modal.Title>{language.modelTitle}</Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Container fluid className="d-flex flex-column align-items-center p-4">
          <LanguageRadioButtons />
          <p className="text-center">{language.subTitle}</p>
          <div className="d-flex justify-content-around w-100">
            <Nav.Link href="/paper" onClick={(e) => handleOpenPaper("/paper")}>
              <Button className="btn model-basic-color m-2">
                {language.allqueButton}
              </Button>
            </Nav.Link>
            <Nav.Link
              href="/spot-paper"
              onClick={(e) => handleOpenPaper("/spot-paper")}
            >
              <Button className="btn model-basic-color m-2">
                {language.oneByoneButton}
              </Button>
            </Nav.Link>
          </div>
        </Container>
      </Modal.Body>
    </Modal>
  );
}

export default ChangePaperModal;
